import { ref, watch } from 'vue';
import { useRoute } from 'vue-router';

export function useNavigation() {
  const route = useRoute();
  const activeNavItem = ref('dashboard');
  const administrationSubView = ref('');
  
  // Watch for route changes and update navigation state
  watch(() => route.meta, (meta) => {
    if (meta.navItem) {
      activeNavItem.value = meta.navItem as string;
    }
    
    if (meta.adminSubView !== undefined) {
      administrationSubView.value = meta.adminSubView as string;
    }
  }, { immediate: true });
  
  return {
    activeNavItem,
    administrationSubView
  };
}
